import React from "react";

import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import LoggedInMenu from "./LoggedInMenu";

interface IOpenSourceProps {
  extern?: boolean;
}

export default class OpenSource extends React.Component<IOpenSourceProps> {
  state: { show: boolean };

  constructor(props: IOpenSourceProps) {
    super(props);
    this.state = { show: false };
  }

  render() {
    return (
      <>
        <Modal
          show={this.state.show}
          centered
          onHide={() => this.setState({ ...this.state, show: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Verwendete OpenSource-Bibliotheken</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>
              Das KVA+-Kundenportal verwendet folgende OpenSource-Bibliotheken:
            </p>
            <ol>
              <li>
                <a href="https://reactjs.org/">React</a> (
                <a href="https://github.com/facebook/react/blob/master/LICENSE">
                  MIT Lizenz
                </a>
                )
              </li>
              <li>
                <a href="https://github.com/apollographql/react-apollo">
                  React Apollo
                </a>{" "}
                (
                <a href="https://github.com/apollographql/react-apollo/blob/master/LICENSE">
                  MIT-Lizenz
                </a>
                )
              </li>
              <li>
                <a href="https://react-bootstrap.github.io/">React Bootstrap</a>{" "}
                (
                <a href="https://github.com/react-bootstrap/react-bootstrap/blob/master/LICENSE">
                  MIT-Lizenz
                </a>
                )
              </li>
              <li>
                <a href="https://react-dropzone.js.org/">React Dropzone</a> (
                <a href="https://github.com/react-dropzone/react-dropzone/blob/master/LICENSE">
                  MIT-Lizenz
                </a>
                )
              </li>
              <li>
                <a href="https://github.com/frontend-collective/react-image-lightbox">
                  React Image Lightbox
                </a>{" "}
                (
                <a href="https://github.com/frontend-collective/react-image-lightbox/blob/master/LICENSE">
                  MIT-Lizenz
                </a>
                )
              </li>
              <li>
                <a href="https://reacttraining.com/react-router/">
                  React Router
                </a>{" "}
                (
                <a href="https://github.com/ReactTraining/react-router/blob/master/LICENSE">
                  MIT-Lizenz
                </a>
                )
              </li>
              <li>
                <a href="https://github.com/react-bootstrap/react-router-bootstrap">
                  react-router-bootstrap
                </a>{" "}
                (
                <a href="https://github.com/react-bootstrap/react-router-bootstrap/blob/master/LICENSE">
                  Apache 2.0-Lizenz
                </a>
                )
              </li>
            </ol>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ ...this.state, show: false })}
            >
              Schließen
            </Button>
          </Modal.Footer>
        </Modal>

        <div
          className={`${this.props.extern ? "extern " : ""}legalinfo-wrapper`}
        >
          <a
            href="#"
            onClick={() => this.setState({ ...this.state, show: true })}
          >
            <span className="icon-info-circled"></span>
          </a>
        </div>
      </>
    );
  }
}
